<template>
  <div class="enterprise_authenticate">
    <router-view/>
  </div>
</template>

<script>
  export default {
    data(){
      return{
        tableSwitch:0,
        certData:null,//认证数据
      }
    },
    created(){
      this.getFrontAuthenticates();
    },
    methods:{
      /** 查询认证*/
      getFrontAuthenticates(){
        let params = {
          type:'CertificationTypeInnovate'
        }
        this.api.getFrontAuthenticates(params).then(res=>{
          if(res.error['err_code'] !== 0) return;
          let list = res.obj.list || [];
          this.certData = list.length?list[0]:null;
          this.tableSwitch = list.length?1:2;
        })
      }
    }
  }
</script>

<style lang="scss">
  @import "../../index.scss";
</style>
